module.exports = __webpack_public_path__ + "static/media/16UNODC28.531c15c5.jpg";